'use client';

import { useIntersectionObserver } from '@/hooks/useIntersectionObserver';
import { cn } from '@/utils/tailwind-merge';
import { useEffect, useRef } from 'react';

const ENVIROMENT = process.env.NODE_ENV;

interface TrailerProps {}

const Trailer = (props: TrailerProps) => {
    const {} = props;
    const baseUrl = ENVIROMENT === 'development' ? '' : '/festival-2024';
    const videoRef = useRef<HTMLVideoElement | null>(null);
    const [ref, isIntersecting] = useIntersectionObserver({
        threshold: 0.5,
    });

    useEffect(() => {
        if (isIntersecting && videoRef.current) {
            videoRef.current.play().catch((error) => {
                console.error('Video playback failed:', error);
            });
        } else if (videoRef.current) {
            videoRef.current.pause();
        }
    }, [isIntersecting]);

    const videoPath = '' + '/video/trailer.webm';

    return (
        <div ref={ref}>
            <video
                width="1280"
                height="720"
                preload="none"
                loop
                poster={`${baseUrl}/img/trailer/image.png`}
                playsInline
                className={cn('w-full h-auto md:h-full')}
                ref={videoRef}
            >
                <source src={baseUrl + videoPath} type="video/webm" />
                Your browser does not support the video tag.
            </video>
        </div>
    );
};

export default Trailer;
